// Fix /Users/kacey/BoxyQR_Website/BoxyQR/boxyQR_website/client/src/utils/auth.js
const getAuthToken = () => {
  return window.Clerk?.session?.getToken();
};

const isAuthenticated = () => {
  return !!window.Clerk?.user;
};

const getUserId = () => {
  return window.Clerk?.user?.id;
};

const getUserEmail = () => {
  return window.Clerk?.user?.primaryEmailAddress?.emailAddress;
};

const getUserName = () => {
  const firstName = window.Clerk?.user?.firstName || '';
  const lastName = window.Clerk?.user?.lastName || '';
  return `${firstName} ${lastName}`.trim();
};

// New function to ensure user exists in database
const ensureUserInDatabase = async () => {
  if (isAuthenticated()) {
    try {
      const clerkId = getUserId();
      const email = getUserEmail();
      
      if (!clerkId || !email) {
        console.error('Missing user information for database creation');
        return;
      }
      
      // First check if the user already exists
      const checkResponse = await fetch(`/api/users/by-clerk/${clerkId}`);
      
      // If user doesn't exist (404), create them
      if (checkResponse.status === 404) {
        console.log('User not found in database, creating...');
        const createResponse = await fetch('/api/create-user', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            clerkId,
            email
          })
        });
        
        if (createResponse.ok) {
          console.log('Successfully created user in database');
        } else {
          console.error('Failed to create user in database');
        }
      } else {
        console.log('User already exists in database');
      }
    } catch (error) {
      console.error('Error ensuring user in database:', error);
    }
  }
};

export {
  getAuthToken,
  isAuthenticated,
  getUserId,
  getUserEmail,
  getUserName,
  ensureUserInDatabase
};